import {ReactNode} from 'react';
import {THeadingTag} from 'coreComponents/SEO/ISeoProps';

export enum EAccordionGroupStyle {
	Default = 'default',
	Contrast = 'contrast',
	AnimatedCaret = 'animatedCaret',
}

export interface IAccordionGroupProps {
	hTag?: THeadingTag;
	style?: EAccordionGroupStyle;
	children: ReactNode;
	activeIndex?: number;
	classNames?: string;
	allowMultipleOpen?: boolean;
}

export interface IAccordionProps {
	title: string;
	content: ReactNode;
	hTag?: THeadingTag;
	expandIcon?: string;
	collapseIcon?: string;
}

export interface IAccordionContext {
	hTag: THeadingTag,
	isActive?: boolean,
	handleClick: () => void,
	expandIcon?: string;
	collapseIcon?: string;
}
